/* eslint-disable */
import notification from '@/audio/notification.mp3'

export const Sounds = {
  notification
}

const soundCache = new Map() // Stores audio downloaded from the database
const playingSounds = new Map() // If only one instance of a sound is supposed to be played at once
const pools = new Map()

class SoundBank {
  store = null; // injected in main.js when the Vue is loading

  playSound(soundUrl) {
    new Audio(soundUrl).play()
  }

  playSoundId(id) {
    if (Sounds[id]) {
      new Audio(Sounds[id]).play()
    }
    else {
      console.error(`Unknown sound ID: ${id}`);
    }
  }

  async playDatabaseSound(id, useCache = false) {
    const url = await this.prepareDatabaseSound(id, useCache)
    const audio = new Audio(url)
    audio.play();
    return audio;
  }

  async prepareDatabaseSound(id, useCache) {
    let url = soundCache.get(id)
    if (!url || !useCache) {
      const audio = await this.store.dispatch('callApi', {name: 'getAudio', payload: {id}}) // Audio as in entity from
      if (audio === null) {throw new Error(`Database audio file with id ${id} could not be loaded (wrong id?)!`)}

      const blob = new Blob([audio.audio], {type: "audio/ogg; codecs=opus"})
      url = URL.createObjectURL(blob)
      soundCache.set(id, url)
    }
    return url;
  }

  togglePool(pool) {
    let pooledAudio = pools.get(pool)
    if (pooledAudio) {
      if (pooledAudio.paused) {
        pooledAudio.play()
      }
      else {
        pooledAudio.pause()
      }
    }
  }

  pausePool(pool) {
    let pooledAudio = pools.get(pool)
    if (pooledAudio) {
      pooledAudio.pause()
    }
  }

  playPool(pool) {
    let pooledAudio = pools.get(pool)
    if (pooledAudio) {
      pooledAudio.play()
    }
  }

  getPooledAudio(pool) {
    return pools.get(pool)
  }

  async playPooledDatabaseSound(id, pool, useCache) {
    const url = await this.prepareDatabaseSound(id, useCache)
    let pooledAudio = pools.get(pool)
    if (pooledAudio) {
      pooledAudio.pause()
      pooledAudio.src = url;
      pooledAudio.currentTime = 0
      pooledAudio.play()
      return pooledAudio
    }
    else {
      const audio = new Audio(url)
      pools.set(pool, audio)
      audio.onended = () => {pools.delete(pool)}
      audio.play()
      return audio
    }
  }

  async playDatabaseSoundOnce(id) {
    const playingAudio = playingSounds.get(id)
    if (playingAudio) {
      playingAudio.currentTime = 0
    }
    else {
      try {
        const audio = await this.playDatabaseSound(id)
        playingSounds.set(id, audio)
        audio.onended = () => {playingSounds.delete(id)}
      } catch (e) {
        console.error(e);
      }
    }
  }
}

export default new SoundBank()
